export const PLAN_REVIEW_JUSTIFICATION_MIN_LENGTH = 20

export const PLAN_REVIEW_JUSTIFICATION_PROMPT =
  'Please provide a justification before this plan can be acknowledged.'

export const PLAN_REVIEW_COMMENTS_SECTION = 'Acknowledgment'

export const PLAN_REVIEW_QUALITY_GROUP_KEYS = {
  summary: 'plan-review-summary',
  financial: 'financial-plan-quality',
  planningMeasure: 'planning-measure',
  initiatives: 'initiatives-plan-quality',
} as const
